import { deleted, downloadFilePost, get, post, put } from 'utils/api';
import { DataResponse } from './response';

// ==========================Lịch sử nhập kho ===============================
// danh sách lịch sử nhập kho
export interface HistoryReceiveModel {
  stt: number;
  id: string;
  receiveCode?: string;
  lotNumber: string;
  workOrderCode: string;
  productName: string;
  kssxNumber: string;
  stepCode: string;
  statusReceive?: string;
  receiveTime: string;
  receiveBy: string;
  soLuongNk: number;
  // loại lsx
  typeLSX?: string;
  // mã tp/btp
  productCode: string;
  // Tổng số phiếu nhập kho
  qtyReceive?: number;
  // Lần nhập kho
  receiveTimes?: number;
  // Ghi chú
  description: string;
  workOrderCompletion?: string;
  // Đơn vị tính 
  dvt: string;
  // số lượng phát lệnh
  slPhatLenh: number
}
// chi tiết lịch sử nhập kho
export interface DetailHistoryReceiveModel {
  receiveCode?: string;
  lotNumber: string;
  workOrderCode: string;
  productName: string;
  productCode: string;
  kssxNumber: string;
  stepCode?: string;
  stepName?: string;
  statusReceive: string;
  receiveTime: string;
  receiveBy: string;
  historyReceives: HistoryReceives[];
  tranDate: string;
  receiveQty?: number;
  woCompletion?: string;
  // Ghi chú
  description: string;
}

export interface HistoryReceives {
  id: string;
  lotNumber: string;
  quantity: number;
  unit: string;
  expirationDate: string | null;
}

// Hủy xác nhận hoàn thành công đoạn
export type CancelConfirmStage = {
  workOrderId: string;
  orderIndex: number;
};

export interface IHistoryReceiveServices {
  getHistorySeceive(data: any): Promise<DataResponse<Array<HistoryReceiveModel>>>;
  getDetailHistoryReceive(data: any): Promise<DataResponse<DetailHistoryReceiveModel>>;
  // Sửa phiếu nhập kho
  editReceveVote(data: any): Promise<DataResponse<null>>;
  // Hủy xác nhận hoàn thành công đoạn
  cancelConfirmStage(data: CancelConfirmStage): Promise<DataResponse<null>>;
  // Nhập lại kho
  syncReceive(data: any): Promise<DataResponse<null>>;
  // Export lịch sử nhập kho
  exportExcelHistoryRecieve(data: any): Promise<void>
}

export function createHistoryRecieveServices(): IHistoryReceiveServices {
  return {
    getHistorySeceive: async (data: any) => {
      return (await post(`MES/StageTranfer/history-receive`, data)).data;
    },
    getDetailHistoryReceive: async (id: string) => {
      return (await get(`MES/StageTranfer/detail-history-receive?ReceiveId=${id}`)).data;
    },
    editReceveVote: async (data: any) => {
      return (await put(`MES/StageTranfer/edit-receive-vote`, data)).data;
    },
    // Hủy xác nhận hoàn thành công đoạn
    cancelConfirmStage: async (data: CancelConfirmStage): Promise<DataResponse<null>> => {
      return (await post(`MES/StageTranfer/cancel-confirm-stage`, data)).data;
    },
    // Nhập lại kho
    syncReceive: async (data: HistoryReceives): Promise<DataResponse<null>> => {
      return (await post(`MES/StageTranfer/sync-receive`, data)).data;
    },
    // Export lịch sử nhập kho
    exportExcelHistoryRecieve: async (data) => {
      await downloadFilePost("MES/StageTranfer/export-excel-history-receive", data);
    }
  };
}
